<template>
  <div>
    <Dialog 
      :visible="value" 
      :style="{ width: '95%', maxWidth: '650px' }" 
      :closable="true"
      :modal="true" 
      :dismissableMask="true"
      :closeOnEscape="!processing" 
      :draggable="false"
      position="center"
      @update:visible="closeDialog"
    >
      <template #header>
        <div class="dialog-header">
          <h2>Cancelamento de Assinatura</h2>
        </div>
      </template>

      <CancellationRetention 
        v-if="currentStep === 1"
        @contact-support="handleContactSupport"
        @continue-cancellation="goToStep(2)" 
      />

      <CancellationIncentive 
        v-if="currentStep === 2"
        @activate-free-months="handleActivateFreeMonths"
        @continue-cancellation="goToStep(3)" 
      />

      <CancellationConfirmation 
        v-if="currentStep === 3" 
        :processing="processing"
        @activate-free-months="handleActivateFreeMonths" 
        @confirm-cancellation="handleConfirmCancellation" 
      />
    </Dialog>
  </div>
</template>

<script>
import Dialog from 'primevue/dialog';
import { useToast } from 'primevue/usetoast';
import { useAppStore } from '@/store/store.js';
import CancellationRetention from './CancellationRetention.vue';
import CancellationIncentive from './CancellationIncentive.vue';
import CancellationConfirmation from './CancellationConfirmation.vue';

export default {
  name: 'CancellationFlow',
  components: {
    Dialog,
    CancellationRetention,
    CancellationIncentive,
    CancellationConfirmation
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentStep: 1,
      processing: false,
      toast: useToast()
    };
  },
  methods: {
    goToStep(step) {
      const store = useAppStore();
      if(step == 2){
        store.sendCancelationSearchEmail()
      }
      if(store.hasFreemiumRenewal && step === 2) {
        return this.handleConfirmCancellation()
      }else{
        this.currentStep = step;
      }
    },
    handleContactSupport() {
      const store = useAppStore();
      const consultantPhone = store.userResponse?.data?.userConsultant?.cell_phone;
      if (consultantPhone) {
        window.open(`https://api.whatsapp.com/send?phone=${consultantPhone}`, '_blank');
      }
      this.closeDialog();
    },

    async handleActivateFreeMonths() {
      try {
        this.processing = true;
        const store = useAppStore();
        if(store.hasFreemiumRenewal) {
          return this.handleConfirmCancellation()
        }
        const response = await store.cancelSubscription({
          renew_freemium: true
        })
        if (response.status === 200) {
          this.toast.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Sua assinatura foi estendida por 3 meses grátis!',
            life: 5000
          });
          const store = useAppStore();
          store.getUser();
        } else {
          this.toast.add({
            severity: 'error',
            summary: 'Erro',
            detail: 'Houve um problema ao estender sua assinatura. Por favor, tente novamente.',
            life: 5000
          });
        }
      } catch (error) {
        this.toast.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Houve um problema ao estender sua assinatura. Por favor, tente novamente.',
          life: 5000
        });
      } finally {
        this.processing = false;
        this.closeDialog();
      }
    },

    async handleConfirmCancellation() {
      try {
        this.processing = true;
        const store = useAppStore();
        const response = await store.cancelSubscription({
          renew_freemium: false
        })
        if (response.status === 200) {
          this.toast.add({
            severity: 'success',
            summary: 'Cancelado',
            detail: 'Sua assinatura foi cancelada com sucesso.',
            life: 5000
          });
          const store = useAppStore();
          store.getUser();
        } else {
          this.toast.add({
            severity: 'error',
            summary: 'Erro',
            detail: 'Houve um problema ao cancelar sua assinatura. Por favor, entre em contato conosco.',
            life: 5000
          });
        }
      } catch (error) {
        this.toast.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Houve um problema ao cancelar sua assinatura. Por favor, entre em contato conosco.',
          life: 5000
        });
      } finally {
        this.processing = false;
        this.closeDialog();
      }
    },

    closeDialog(event) {
      this.currentStep = 1;
      this.$emit('input', false);
    }
  }
}
</script>

<style scoped>
.dialog-header {
  text-align: center;
  width: 100%;
}

.dialog-header h2 {
  color: #fff;
  font-size: 24px;
  margin: 0;
}

:deep(.p-dialog-header) {
  padding: 1.5rem 1.5rem 0.5rem 1.5rem;
  background-color: #283045;
  color: #fff;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}

:deep(.p-dialog-content) {
  background-color: #283045;
  color: #e4e4e4;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  padding: 0 1.5rem 1.5rem 1.5rem;
}

:deep(.p-dialog-footer) {
  background-color: #283045;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  padding: 0 1.5rem 1.5rem 1.5rem;
}

:deep(.p-dialog) {
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
}
</style>
